









































































import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
  components: {
  }
})
export default class FloorComponent extends Vue {
  @Prop({ default: () => ({}) }) readonly info!: any

  getOneGroupPerRowSliceIndex(length: number) {
    if (length >= 4) {
      return 4
    } else if (length >= 2 && length < 4) {
      return 2
    }
  }

  getTowGroupPerRowIsC1per1row(floor: any) {
    return this.exsitGroupListLength1(floor)
  }

  existGroupListLength0(floor: any) {
    return floor.groupList.find((item: any) => item.list && item.list.length === 0)
  }

  exsitGroupListLength1(floor: any) {
    return (floor && floor.groupList && 
    !this.existGroupListLength0(floor) &&
    floor.groupList.find((item: any) => item.list && item.list.length === 1))
  }

  isShowGroupType2ViewFloor(floor: any) {
    return floor.groupType === 2 && floor.isShow && floor.groupList && floor.groupList.length >= 2 && !this.existGroupListLength0(floor)
  }

  getTowGroupPerRowSliceIndex(exsitGroupListLength1: boolean) {
    if (exsitGroupListLength1) {
      return 1
    } else {
      return 2
    }
  }

  handleClick(params: {item?: any; columGroup?: any}) {
    if (params?.item?.link) {
      location.href = params.item.link
      
    } else if (params?.columGroup?.link) {
      location.href = params?.columGroup?.link
    }
    this.$emit('itemClick', params)
  }
}
